'use client';

import * as DS from '@aurorasolar/ds';
import { th } from '@xstyled/styled-components';
import { styled } from 'styled-components';

import { FAQS } from '../content';

// Native <details> with the default marker hidden. A plus on the right rotates
// into a minus when open (DS has no accordion pattern; mirrors the website DS).
const Disclosure = styled.details`
  padding-bottom: 12px;
  border-bottom: 1px solid ${th.color('uiDivider')};

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 0;
    cursor: pointer;
    list-style: none;
  }
  summary::-webkit-details-marker {
    display: none;
  }

  .faq-toggle {
    position: relative;
    flex: none;
    width: 14px;
    height: 14px;
  }
  .faq-toggle span {
    position: absolute;
    background-color: ${th.color('uiBodyCopy')};
    border-radius: 9999px;
  }
  .faq-toggle .horizontal {
    top: 50%;
    left: 0;
    width: 14px;
    height: 2px;
    transform: translateY(-50%);
  }
  .faq-toggle .vertical {
    top: 0;
    left: 50%;
    width: 2px;
    height: 14px;
    transform: translateX(-50%);
    transition: transform 200ms ease;
  }
  &[open] .faq-toggle .vertical {
    transform: translateX(-50%) rotate(90deg);
  }
`;

export const FaqSection = () => (
  <DS.Flex gap={3} maxW="640px" mx="auto" w="100%">
    <DS.Text as="h2" text="h1">
      Frequently asked questions
    </DS.Text>
    <DS.Flex gap={2}>
      {FAQS.map(({ answer, question }) => (
        <Disclosure key={question}>
          <summary>
            <DS.Text as="span" fontWeight="medium" text="body16">
              {question}
            </DS.Text>
            <span aria-hidden="true" className="faq-toggle">
              <span className="horizontal" />
              <span className="vertical" />
            </span>
          </summary>
          <DS.Text color="uiHelperCopy" pt={1} text="body14">
            {answer}
          </DS.Text>
        </Disclosure>
      ))}
    </DS.Flex>
  </DS.Flex>
);
